export const ReportStatusColorCodes: any = {
  'Configuration in progress': '#B5E1E6',
  'Analysis complete': '#B1E7A0',
  'Analysis in progress': '#B5E1E6',
  'Analysis incomplete': '#FFCDA3',
  'Cost planning incomplete': '#FFCDA3',
  'Cost planning complete': '#B1E7A0',
  'Cost planning in progress': '#B5E1E6',
  'Pending permission': '#FFC1A9',
  Started: '#B5E1E6',
  Error: '#FF9675',
};

export const NEW_REPORT_INTERNAL_STATUS_ROUTES: any = {
  DATA_LOAD_PENDING: 'DATA_LOAD_PENDING',
  DATA_LOAD_FAILED: 'DATA_LOAD_FAILED',
  DATA_LOAD_DONE: 'DATA_LOAD_DONE',
  FILE_UPLOAD_DONE: 'FILE_UPLOAD_DONE',
  COMPATIBILITY_CHECK_IN_PROGRESS: 'COMPATIBILITY_CHECK_IN_PROGRESS',
  POPULATION_SCOPE_IN_PROGRESS: 'POPULATION_SCOPE_IN_PROGRESS',
  COMPENSATION_DONE: 'COMPENSATION_DONE',
  DEMOGRAPHICS_DONE: 'DEMOGRAPHICS_DONE',
  GROUPS: 'GROUPS',
  PAY_FACTORS: 'PAY_FACTORS',
  DATA_VALIDATION: 'DATA_VALIDATION',
  REVIEW_AND_RUN: 'REVIEW_AND_RUN',
  ERROR: 'ERROR',
  ANALYSIS_COMPLETE: 'ANALYSIS_COMPLETE',
  COST_PLANNING_COMPLETE: 'COST_PLANNING_COMPLETE',
  COST_PLANNING_INPROGRESS: 'COST_PLANNING_INPROGRESS',
  COST_PLANNING_INCOMPLETE: 'COST_PLANNING_INCOMPLETE',
};

export const STATUS_DISPLAY_GROUP: Record<string, string> = {
  DATA_LOAD_PENDING: 'CONFIGURATION_IN_PROGRESS',
  DATA_LOAD_FAILED: 'CONFIGURATION_IN_PROGRESS',
  DATA_LOAD_DONE: 'CONFIGURATION_IN_PROGRESS',
  FILE_UPLOAD_DONE: 'CONFIGURATION_IN_PROGRESS',
  COMPENSATION_DONE: 'CONFIGURATION_IN_PROGRESS',
  DEMOGRAPHICS_DONE: 'CONFIGURATION_IN_PROGRESS',
  GROUPS: 'CONFIGURATION_IN_PROGRESS',
  PAY_FACTORS: 'CONFIGURATION_IN_PROGRESS',
  DATA_VALIDATION: 'CONFIGURATION_IN_PROGRESS',
  REVIEW_AND_RUN: 'CONFIGURATION_IN_PROGRESS',
};

export const ReportStatusId: any = {
  ConfigurationInProgress: 'Configuration in progress',
  AnalysisComplete: 'Analysis complete',
  AnalysisInComplete: 'Analysis incomplete',
  CostPlanningComplete: 'Cost planning complete',
  CostPlanningInComplete: 'Cost planning incomplete',
  CostPlanningInprogress: 'Cost planning in progress',
  PendingPermission: 'Pending permission',
  AnalysisInProgress: 'Analysis in progress',
  Started: 'Started',
  Error: 'Error',
};

// 'Cost planning in progress': '#C7D7FF',
// 'Started':'#B5E1E6',
// 'Error':'#B5E1E6',
// 'Analysis incomplete': '#C0DFD5',